export const GET_ALL_ITEM_CATEGORIES = 'GET_ALL_ITEM_CATEGORIES';
export const GET_ALL_MARKET_CATEGORIES = 'GET_ALL_MARKET_CATEGORIES';
export const GET_ALL_ITEMS = 'GET_ALL_ITEMS';
export const GET_ITEM_SCHEDULE_DATA = 'GET_ITEM_SCHEDULE_DATA';
export const GET_SINGLE_ITEM = 'GET_SINGLE_ITEM'
export const GET_ALL_ITEM_GROUPS = 'GET_ALL_ITEM_GROUPS';
export const ADD_ITEM_ADDON = "ADD_ITEM_ADDON";
export const UPDATE_ITEM_ADDON = "UPDATE_ITEM_ADDON";
export const DELETE_ITEM_ADDON = "DELETE_ITEM_ADDON";
